import axios from 'axios';

import {ExternalUrl} from '~/utils/routes';

const instance = axios.create({
  timeout: 0,
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        window.location.href = ExternalUrl.Logout;
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
